import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SystemFlowService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getAllSystemFlow() {
    return this.http.get<any[]>('/api/systemFlow/getAllSystemFlow');
  }

  getSystemFlow(metaFlowId: number) {
    return this.http.get<any>(`api/systemFlow/getMetaFlow/${metaFlowId}`);
  }

  getMetaFlowPools(metaFlow: any) {
    return this.http.post<any[]>('api/systemFlow/getMetaflowPools', metaFlow);
  }

  getSystemflowDesignerLink(systemFlowName: string) {
    return this.http.get<any>(`api/systemFlow/getSystemflowDesignerLink?systemFlowName=${systemFlowName}`);
  }

  createSystemFlow(metaFlow: any) {
    return this.http.post<void>('api/systemFlow/createSystemFlow', metaFlow);
  }

  updateSystemFlow(metaFlow: any) {
    return this.http.put('api/systemFlow/updateSystemFlow', metaFlow);
  }

  removeSystemFlow(systemFlowMetaFlow: any) {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: systemFlowMetaFlow ,
    };
    return this.http.delete('api/systemFlow/removeSystemFlow', options);
  }

  exportSystemFlow(systemFLowId: number, systemFlowName: string): Observable<HttpEvent<Blob>> {
    return this.http.request(new HttpRequest(
      'GET',
      `api/systemFlow/export/${systemFLowId}?systemFlowName=${systemFlowName}`,
      null,
      {
        reportProgress: true,
        responseType: 'blob'
      }));
  }

  importSystemFlow(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post('api/systemFlow/uploadSystemFlow', formData, {reportProgress: true, observe: 'events'});
  }
}
